import { configureStore } from "@reduxjs/toolkit";
import authReducer from "./authSlice";
import jobReducer from "./jobSlice";
import subscribeReducer from "./subscribeSlice";
import promptReducer from "./promptSlice";
import popupReducer from "./popupSlice";
import hackathonReducer from "./hackathonSlice";
import blogReducer from "./blogSlice";

const store = configureStore({
  reducer: {
    auth: authReducer,
    job: jobReducer,
    subscribe: subscribeReducer,
    prompt: promptReducer,
    popup: popupReducer,
    hackathon: hackathonReducer,
    blog: blogReducer,
  },
});

export default store;
